import { useTranslation } from 'react-i18next'

import {
  TUnityHubCreateChannelsMembersStepProps,
  UnityHubCreateChannelsMembersStep
} from 'App/components/UnityHub/UnityHubCreateChannels'
import { TGetEventAttendeesPayload } from 'api/events'

import { useEventCreateChannelMembersStepRequest } from './useEventCreateChannelMembersStepRequest'

export type TEventCreateChannelMembersStepProps = Pick<
  TUnityHubCreateChannelsMembersStepProps,
  | 'setChannelManagers'
  | 'setChannelMembers'
  | 'onSubmit'
  | 'onBack'
  | 'error'
  | 'submitLoading'
  | 'channelMembers'
  | 'channelManagerIds'
  | 'variant'
  | 'maxSelected'
> &
  Pick<TGetEventAttendeesPayload, 'markChatIds'> & {
    eventId: string
  }

export const EventCreateChannelMembersStep = ({
  channelMembers,
  eventId,
  channelManagerIds,
  variant,
  maxSelected,
  submitLoading,
  error,
  markChatIds,
  onBack,
  onSubmit,
  setChannelManagers,
  setChannelMembers
}: TEventCreateChannelMembersStepProps) => {
  const { t } = useTranslation()

  const {
    error: innerError,
    results,
    total,
    page,
    search,
    showBy,
    loading,
    setPage,
    handleSearch
  } = useEventCreateChannelMembersStepRequest({ eventId, markChatIds })

  return (
    <UnityHubCreateChannelsMembersStep
      emptyListText={t('modal.createChannel.selectMembers.placeholder')}
      variant={variant}
      items={results}
      total={total}
      limit={showBy}
      page={page}
      search={search}
      maxSelected={maxSelected}
      error={error ?? innerError}
      channelMembers={channelMembers}
      channelManagerIds={channelManagerIds}
      submitLoading={submitLoading}
      loading={loading}
      onBack={onBack}
      onSubmit={onSubmit}
      onPageChange={setPage}
      onSearch={handleSearch}
      setChannelMembers={setChannelMembers}
      setChannelManagers={setChannelManagers}
    />
  )
}
